<template lang="pug">
  .preorder-article
    .row
      button.button.is-small.is-link.decrease(
        @click.prevent.stop="decrease"
        :disabled="!valid || !article || articlePivot.qty <= 0"
      )
        svg(xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor")
          path(stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4")
      input(
        ref="input"
        :class="{ 'out-of-stock': manageStock && article && articlePivot.qty && articlePivot.qty > article.qty_sum }"
        type="number"
        min="0"
        max="1000"
        step="1"
        v-model="qty"
        :disabled="!valid || !article"
      )
      button.button.is-small.is-link.increase(
        @click.prevent.stop="increase"
        :disabled="!valid || !article || manageStock && articlePivot.qty >= article.qty_sum"
      )
        svg(xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor")
          path(stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6")
    transition(name="slide-fade-down")
      .price(v-if="showPrices")
        nobr(:class="{ strikethrough: salePrice }") {{ price }}
        nobr.sale(v-if="salePrice") {{ salePrice }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { get } from '@/helpers';
import { moneyFormat } from '@/filters';

// TODO
// pay attention to stock

export default {
  name: 'PreorderArticle',
  props: {
    article: {
      type: Object,
      required: false
    },
    manageStock: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: true
    },
    showPrices: {
      type: Boolean,
      default: false
    }
  },
  // computed: {
  // }
  computed: {
    qty: {
      get() {
        return this.articlePivot.qty || undefined;
      },
      set(qty) {
        if (this.article) {
          if (this.manageStock && qty > this.article.qty_sum) {
            qty = this.article.qty_sum;
            this.$refs.input.value = qty;
            this.$refs.input.classList.add('out-of-stock');
            setTimeout(() => {
              this.$refs.input.classList.remove('out-of-stock');
            }, 600);
          }
          this.updateArticleQtyInCart({ article: this.article, qty });
        }
      }
    },
    price() {
      if (!this.article.price) return null;

      const code =
        get(this.customer, 'customerGroup.currency.iso4217') ||
        get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
        'EUR';

      let key = 'value';
      if (this.customer && get(this.customer, 'show_net_prices')) key = 'net_value';

      return moneyFormat(this.article.price[key], code);
    },
    salePrice() {
      // return '20,99 €';
      if (!this.article.salePrice) return null;

      const code =
        get(this.customer, 'customerGroup.currency.iso4217') ||
        get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
        'EUR';

      let key = 'value';
      if (this.customer && get(this.customer, 'show_net_prices')) key = 'net_value';

      return moneyFormat(this.article.salePrice[key], code);
    },
    articlePivot() {
      // find in cart
      // or define default object

      const articlePivots = get(this.cart, 'articlePivots') || [];
      let articlePivot;
      if (this.article) {
        articlePivot = articlePivots.find(el => el.article.id === this.article.id);
      }

      if (!articlePivot) {
        let available = true;
        if (this.manageStock && this.article && this.article.qty_sum <= 0) available = false;

        articlePivot = {
          qty: 0,
          article: undefined,
          available
        };
      }
      return articlePivot;
    },
    ...mapGetters({
      customer: 'shop/customer',
      defaultCustomerGroup: 'shop/defaultCustomerGroup',
      defaultTax: 'shop/defaultTax',
      cart: 'shop/cart'
    })
  },
  methods: {
    increase() {
      if (this.article) {
        this.addArticleToCart({ article: this.article, manageStock: this.manageStock });
      }
    },
    decrease() {
      if (this.article) {
        this.removeArticleFromCart({ article: this.article });
      }
    },
    ...mapActions({
      addArticleToCart: 'shop/addArticleToCart',
      removeArticleFromCart: 'shop/removeArticleFromCart',
      updateArticleQtyInCart: 'shop/updateArticleQtyInCart'
    })
  }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

.preorder-article .row
  @apply flex justify-between
  top: calc(50% - 1rem - 2px)
  left: 0
  right: 0
  // display: none
  width: 100%
  height: 2rem
  input
    // border-gray-200
    @apply rounded-none outline-none text-center border-none
    margin: 0 2px
    height: 30px
    -moz-appearance: textfield
    &::-webkit-inner-spin-button, ::-webkit-outer-spin-button
        -webkit-appearance: none
        margin: 0
    &:focus,
    &:active
      @apply outline-none
      z-index: 1
    &[disabled]
      box-shadow: none !important
    &.out-of-stock
      @apply text-red-500
      box-shadow: 0 0 0 0.125rem rgba($red, 0.5)
  button.button
    padding: .3rem
    width: 2rem
    height: 2rem
    color: #fff
    &:hover
      background-color: #fff !important
    &:focus,
    &:active
      z-index: 1
  button.increase
    background-color: #00A35A
  button.decrease
    background-color: #E6052D

.price
  @apply text-gray-500
  font-size: 0.85rem
  padding: 0.2rem 0.6rem
  text-align: center

nobr.strikethrough
  font-size: 0.8em
  opacity: 0.6
  &:before
    border-top: 1px solid

.price nobr + nobr.sale
  margin-left: 0.6rem
  color: $red
</style>
